import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const ActiveSeckill: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            ActiveSeckill
        </div>
    )
}

export const ActiveSeckillSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        ActiveSeckill
    </div>
}

export default ActiveSeckill